import Vue from 'vue';
import App from './components/app';
const id = 'room-booking'; 

const container = document.getElementById(id); 
 
if (container) {
new Vue({
    el: `#${id}`, 
    render: h => h(App), 
});
}




  

   